module.exports = __webpack_public_path__ + "img/title4.1f7e8cdd.png";